import Vue from 'vue'

Vue.filter('hideMobile', value => {
  if (!value) return ''
  value = String(value)
  return value.replace(value.substring(3, 7), '****')
})
